import { defineFcm } from '../shared/factory';

export const FCM_DECISION_MAKER_UPDATES_VIA_PETITION_SERVICE = defineFcm('decision_maker_updates_via_petition_service')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Decision Maker Admin',
		description:
			'If true, updateDecisionMaker calls petition_service instead of monorail for the decision-maker CRUD update [CHANGE-97607].',
		import: false,
	});
